import { defineMessages } from "react-intl";
import {
	diseasesMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/comorbidities/cardiovascularDiseases";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	cardiovascularDiseases: {
		id: "form.cardiovascular_diseases",
		defaultMessage: "Szív és érrendszeri betegségek"
	},
	diseases: {
		id: "form.cardiovascular_diseases.diseases",
		defaultMessage: "Betegség"
	},
	comment: {
		id: "form.cardiovascular_diseases.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	diseases: {
		type: "field",
		path: ["diseases"],
		label: messages.diseases,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: diseasesMessages } }
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.diseases }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "cardiovascularDiseases",
	value: {
		title: messages.cardiovascularDiseases,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
